module.exports = __webpack_public_path__ + "media/base/subcontractor_small-53d6892d.svg";